import { ResponsiveContainer, AreaChart, Area, LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ComposedChart } from "recharts";
import { Box, Heading } from "@chakra-ui/react";

// ข้อมูลการผลิตและส่งมอบวัคซีนย้อนหลัง 12 เดือน
const data = [
  { month: "เม.ย. 67", Production: 1200, Delivery: 900 },
  { month: "เม.ย. 67", Production: 1100, Delivery: 950 },
  { month: "มิ.ย. 67", Production: 1300, Delivery: 1100 },
  { month: "ก.ค. 67", Production: 1400, Delivery: 1150 },
  { month: "ส.ค. 67", Production: 1250, Delivery: 1200 },
  { month: "ก.ย. 67", Production: 1500, Delivery: 1300 },
  { month: "ต.ค. 67", Production: 1600, Delivery: 1400 },
  { month: "พ.ย. 67", Production: 1700, Delivery: 1350 },
  { month: "ธ.ค. 67", Production: 1800, Delivery: 1450 },
  { month: "ม.ค. 68", Production: 1550, Delivery: 1500 },
  { month: "ก.พ. 68", Production: 1650, Delivery: 1550 },
  { month: "มี.ค. 68", Production: 1750, Delivery: 1600 },
];

// สีของแต่ละข้อมูล
const COLORS = {
  production: "#a2d2ff", // ฟ้าอ่อน
  delivery: "#ff8531", // ส้มอ่อน
};

export function ProductionAndDeliveryChart() {
  return (
    <Box w="100%" m={5}>
      <Heading size="md" mb={4}>ปริมาณการผลิตและการส่งมอบวัคซีนย้อนหลัง 12 เดือน</Heading>
      <ResponsiveContainer width="90%" height={300}>
        <ComposedChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Legend />

          {/* Area Chart - ปริมาณการผลิต */}
          <Area type="monotone" dataKey="Production" fill={COLORS.production} stroke={COLORS.production} name="ปริมาณการผลิต" />

          {/* Line Chart - ปริมาณการส่งมอบ */}
          <Line type="monotone" dataKey="Delivery" stroke={COLORS.delivery} strokeWidth={2} dot={{ r: 3 }} name="ปริมาณการส่งมอบ" />
        </ComposedChart>
      </ResponsiveContainer>
    </Box>
  );
}


